import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { makeStyles } from 'tss-react/mui';
import { NavLink } from 'react-router-dom';
import CaretDown from '@components/Icons/CaretDown';
const useStyles = makeStyles()((theme) => ({
    selected: {
        color: `${theme.palette.primary.main} !important`,
        background: 'transparent !important',
        [theme.breakpoints.up('md')]: {
            '&:after': {
                content: "''",
                display: 'block',
                position: 'absolute',
                height: '3px',
                bottom: '0',
                left: '0',
                right: '0',
                background: theme.palette.primary.main,
                pointerEvents: 'none',
            },
        },
        [theme.breakpoints.down('md')]: {
            borderRight: `6px solid ${theme.palette.primary.main} !important`,
            '& i, & span': {
                color: theme.palette.primary.main,
            },
        },
    },
    caret: {
        marginLeft: '10px',
    },
}));
const Content = ({ icon, linkText, downCaret, iconStyles, classes }) => (_jsxs(_Fragment, { children: [icon && (_jsx(ListItemIcon, { classes: { root: iconStyles || undefined }, "data-testid": "nav item icon", children: icon })), _jsx(ListItemText, { primary: linkText }), downCaret && _jsx(CaretDown, { className: classes.caret })] }));
const NavItem = ({ href = '', to = '', icon, linkText, className, iconStyles, button = false, selected = false, downCaret = false, ...props }) => {
    const { classes, cx } = useStyles();
    const contentProps = {
        icon,
        linkText,
        downCaret,
        iconStyles,
        classes,
    };
    if (button) {
        return (_jsx(ListItem, { button: true, ...props, classes: { selected: classes.selected, root: className || undefined }, children: _jsx(Content, { ...contentProps }) }));
    }
    if (href) {
        return (_jsx(ListItem, { component: "a", ...props, href: href, selected: selected, className: cx(className, selected && classes.selected), classes: { selected: classes.selected, root: className || undefined }, children: _jsx(Content, { ...contentProps }) }));
    }
    if (to || (!href && !button)) {
        const isOnNextJsPage = typeof window !== 'undefined' && window.location.pathname.startsWith('/content');
        const commonClassName = cx(className, selected && classes.selected);
        const commonClasses = { selected: classes.selected, root: className || undefined };
        if (isOnNextJsPage && to) {
            return (_jsx(ListItem, { component: "a", href: to, ...props, className: commonClassName, classes: commonClasses, children: _jsx(Content, { ...contentProps }) }));
        }
        return (_jsx(ListItem, { component: NavLink, to: to, activeClassName: "selected", ...props, exact: true, className: commonClassName, classes: commonClasses, children: _jsx(Content, { ...contentProps }) }));
    }
    return _jsx(_Fragment, {});
};
export default NavItem;
